import React, { FC } from 'react';
import type { IColumnInfo } from '@dbl/core/dataSource';
import { Dropdown } from 'tea-component';
import {
  DynamicStaticDateSelect,
  NumberSelect,
  StringSelect
} from '@/pages/datalab/components/SortableDrag/select/type_select';
import { dateType, numberType, stringType } from '@/pages/datalab/components/SortableDrag/typeDefine';
import { TDispatchFun, TItemOnChange } from '@/pages/datalab/components/SortableDrag/configration';
import { DropdownIcon } from '@/pages/datalab/components/SortableDrag/Sortable/dropdownIcon';
import { DateGranularityText } from '@dbl/core/date';
import type { IGetTableInfoDto } from '@dbl/services/dataSource';
import {ITableJoinRelation} from "@/pages/datalab/pages/Multidimensional/Analysis/components/HeaderData/interface";

export const dropdownCard: FC<{
  sortableKey: string;
  item: IColumnInfo;
  sortableOption: any;
  setSortableOption: Function;
  dispatchFun: TDispatchFun;
  itemOnChange: TItemOnChange;
  locale: string;
  clickRename: Function; // 重命名的操作
  updateHandle: Function;
  showCustomColumnModel: Function; // 打开自定义字段的编辑弹窗
  dataTables: IGetTableInfoDto[];
  dataTableJoinRelations: ITableJoinRelation[];
  system: string;
  isDisabledCompare: boolean;
}> = ({ item, itemOnChange, locale, clickRename, updateHandle, showCustomColumnModel, dataTableJoinRelations, dataTables, system, isDisabledCompare }) => {
  let type = dateType.values.includes(item.column_type || '') ? 'date' : '';
  type = stringType.values.includes(item.column_type || '') ? 'string' : type;
  type = numberType.values.includes(item.column_type || '') ? 'number' : type;
  const displayName = item.column_display || item.column_name; // 字段名称展示不区分中英文
  switch (type) {
    case 'date': {
      const isEn = locale === "en-US";
      return (
        <Dropdown
          trigger="click"
          updateOnChildrenChange={true}
          placementOffset={[-7, 5]}
          clickClose={false}
          // overlayClassName={'dbl-date-filter-dropdown'}
          boxStyle={{minWidth: 448}}
          button={(<div className={`dtb-dl-filter-date-wrap ${item.column_granularity === 'hour' ? 'hour-select' : ''}`}>
            <div className="dt-multiple-dropdown-group">
              <div className="dtb-dl-filter-date-text" style={{ paddingRight: '6px' }}>
                {displayName} ({isEn ? "belong" : "属于"}):  {`${DateGranularityText[item?.dateType || 'day']?.[isEn ? 'en' : 'cn']}  `}
                {item.column_text}
              </div>
              <DropdownIcon />
            </div>
          
          </div>)}
        >
          {
            (close) => (<DynamicStaticDateSelect item={item} isDisabledCompare={isDisabledCompare} itemOnChange={itemOnChange} clickRename={clickRename} close={close} updateHandle={updateHandle} showCustomColumnModel={showCustomColumnModel}/>)
          }
        </Dropdown>
      );
    }
    case 'number': {
      return (
        <Dropdown
          trigger="click"
          updateOnChildrenChange={true}
          placementOffset={[-7, 5]}
          clickClose={false}
          // open={item.column_open}
          // onOpen={() => {
          //   itemOnChange({
          //     ...item,
          //     column_open: true,
          //   });
          // }}
          // onClose={() => {
          //   itemOnChange({
          //     ...item,
          //     column_open: false,
          //   });
          // }}
          button={
            <div className="dt-multiple-dropdown-group">
              <div className="dt-multiple-dropdown-text">{`${displayName}: ${item.column_text}`}</div>
              <DropdownIcon />
            </div>
          }
        >
          {
            (close) => (<NumberSelect system={system} item={item} itemOnChange={itemOnChange} clickRename={clickRename} close={close} updateHandle={updateHandle}/>)
          }
        </Dropdown>
      );
    }
    default: {
      
      return (<StringSelect system={system} item={item} itemOnChange={itemOnChange} clickRename={clickRename} updateHandle={updateHandle} dataTableJoinRelations={dataTableJoinRelations} dataTables={dataTables}
      
      />);
      
    }
  }
};
